import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { FowlSlotBonusResult } from "model/results/fowl-slot-bonus-result";

export class FowlSlotSpinsRemainingDecision extends Decision {
    public evaluate(): Exit {
        const gameplay = gameState.getCurrentGame();
        const result = gameplay.getLatestResultOfType(FowlSlotBonusResult);

        if (result.totalSpins > gameplay.getFreespinsPlayed()) {
            return Exit.True;
        } else {
            return Exit.False;
        }
    }

}
